export default __webpack_public_path__ + "static/media/priestofmitrabg.3a7b1c98.jpg";